{
  "active": "Aktiv",
  "associateToType": "Knytt til kostnadstype",
  "closedEvent": "Lukka event",
  "completed": "Gjennomført",
  "contactRegistererd": "kontakt har eigeninnsats registrert på denne eventen.",
  "contactsRegistered": "kontakter har eigeninnsats registrert på denne eventen.",
  "copyRegistrationLink": "Kopier registreringslenke",
  "couldNotCreateEvent": "Kunne ikkje opprette event. Vennlegst prøv igjen.",
  "couldNotDeleteEvent": "Kunne ikkje slette event. Vennlegst prøv igjen.",
  "couldNotEditEvent": "Kunne ikkje redigere event. Vennlegst prøv igjen",
  "createEvent": "Opprett event",
  "deleteEventWarning": "Er du heilt iskker på at dette eventet skal slettast? All eigeninnsats knytta til dette eventet blir sletta.",
  "editEvent": "Rediger event",
  "errorCode.DatesOutsideOfParent": "Tidsrom for event er utenfor prosjekt/aktivitet sitt tidsrom",
  "errorCode.ExpenseTypesNotPresentInProject": "Kostnadstypene du prøver å føre på finnes ikke på prosjekt/aktivitet",
  "eventDescription": "Eventbeskrivelse",
  "eventName": "Namn på event",
  "eventOverview": "Eventoversikt",
  "eventParticipants": "Eventdeltakarar",
  "expectedDuration": "Forventa varigheit",
  "getRegistrartionInfo": "Hent registreringsinformasjon",
  "hours": "timar",
  "linkCopied": "Lenke kopiert!",
  "location": "Stad",
  "minutes": "minutt",
  "newEvent": "Nytt event",
  "noParticipantsRegistered": "Ingen deltakarar registrert",
  "numberOfEvents": "Antal eventer",
  "numberOfEventsDistributedOnActivities": "fordelt på {{activityCount}} aktivitetar",
  "printQrCode": "Print QR-kode",
  "qrCodeDescription": "Print QR-koda og ha den tilgjengeleg for rask registrering av eigeninnsats på eventet ditt.",
  "qrCodeFor": "QR-kode for",
  "qrCodeForRegistering": "QR-kode for oppmøteregistrering på ",
  "qrCodeSidebarDescription": "Deltakarar kan sjølv registrere eigeninnsats via QR-kode på eventet eller frå ei lenkje du sender til dei på epost.",
  "registrationLink": "Registreringslenke",
  "scanQrCode": "Skann QR-koda for å åpne registreringslenka.",
  "selectEvent": "Velg event",
  "selfRegistration": "Eigenregistrering",
  "showAllContacts": "Vis alle kontakter med registrert eigeninnsats på denne eventen:",
  "upcoming": "Komande",
  "uploadLogo": "Last opp logo (ikkje obilgatorisk)"
}
